import React from 'react';
import styled, { css } from 'styled-components';
import { Size } from '../../common/size';
import { Variant } from '../../common/variant';
import { useTestId } from '../../hooks/useTestId';
import { Icon, IconNames } from '../Icons/Icon';
import { CircularIcon } from '../Icons/CircularIcon';

const hiddenSvgCirclePartCss = css`
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  circle {
    &:first-of-type {
      stroke-opacity: 0;
    }
  }
`;

interface INotificationIconContainerProps {
  variant: Variant;
  removeCirclePart?: boolean;
}

//we have to use this <span/> to wrap <svg />. Or it will show an console warning of 'React does not recognize the `removeCirclePart` prop on a DOM element'
//if we add prop which does not belong to svg
const NotificationIconContainer = styled.span<Pick<INotificationIconContainerProps, 'removeCirclePart'>>`
  width: 1.5rem;
  height: 1.5rem;
  ${Icon} {
    ${({ removeCirclePart }) =>
      removeCirclePart
        ? hiddenSvgCirclePartCss
        : css`
            stroke-width: 0.175rem;
          `};
  }
`;

const iconVariations: Record<Variant, keyof typeof IconNames> = {
  [Variant.Success]: IconNames.Check,
  [Variant.Info]: IconNames.Info,
  [Variant.Error]: IconNames.AlertCircle
};

export interface INotificationIconProps {
  variant: Variant;
}

export const NotificationIcon: React.FC<INotificationIconProps> = ({ variant, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'NotificationIcon');
  const iconVariation = iconVariations[variant];

  return (
    <NotificationIconContainer removeCirclePart={iconVariation === IconNames.AlertCircle || iconVariation === IconNames.Info} {...generateTestId()}>
      <CircularIcon variant={variant} name={IconNames[iconVariation]} size={Size.Small} {...generateTestId('Icon')} />
    </NotificationIconContainer>
  );
};
